import React, { useEffect } from "react";
import "../../styles/OrgManageTeams.css";
import { useNavigate, useLocation } from "react-router-dom";

const OrgManageTeams: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const orgDetails = location.state?.orgDetails;

  useEffect(() => {
    // console.log("Received orgDetails:", orgDetails);
  }, [orgDetails]);

  //  Condition check
  const isUninitialized =
    orgDetails?.enabled === false && orgDetails?.initialized === false;

  return (
    <div
      className="org-manage-container"
      style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}
    >
      {/*  Always include Server Configuration (visible alone or with others) */}
      <div
        className="config-card clickable"
        onClick={() =>
          navigate("/server-config", {
            state: { orgDetails, mode: "view" },
          })
        }
      >
        <h2 className="config-title">Server Configuration</h2>
        <p className="config-text">
          Manage organization server configurations here.
        </p>
      </div>

      {/* ✅ Show other configurations only when not both false */}
      {!isUninitialized && (
        <>
          <div
            className="config-card clickable"
            onClick={() => navigate("/general-configurations", { state: { orgDetails }})}
          >
            <h2 className="config-title">General Configuration</h2>
            <p className="config-text">
              Configuration options for general go here.
            </p>
          </div>

          <div
            className="config-card clickable"
            onClick={() =>
              navigate("/level-configurations", { state: { orgDetails } })
            }
          >
            <h2 className="config-title">Level Configuration</h2>
            <p className="config-text">
              Configuration options for levels go here.
            </p>
          </div>

          <div
            className="config-card clickable"
            onClick={() =>
              navigate("/streak-configurations", { state: { orgDetails } })
            }
          >
            <h2 className="config-title">Streak Configuration</h2>
            <p className="config-text">
              Configuration options for streaks go here.
            </p>
          </div>

          <div
            className="config-card clickable"
            onClick={() => navigate("/plugin-configurations", { state: { orgDetails }})}
          >
            <h2 className="config-title">Plugin Configuration</h2>
            <p className="config-text">
              Configuration options for plugins go here.
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default OrgManageTeams;
